import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import get from 'lodash/get.js';

import { trackEvent } from 'dibs-tracking';

import { ContemporaryLandingHeaderModule } from '../ContemporaryLandingHeaderModule/ContemporaryLandingHeaderModule.jsx';

import styles from './ContemporaryLandingFurnitureTileModule.module.css';

const trackClick = item =>
    trackEvent({
        action: 'featured Promotion #2',
        category: 'contemporary landing page interaction',
        label: `${item.caption} clicked|${item.cta}`,
    });

const ContemporaryLandingFurnitureTileModuleComponent = ({ contemporaryLandingRow }) => {
    const item = get(contemporaryLandingRow, 'items[0]');
    if (!item) {
        return null;
    }

    const { cta, imagePath, caption, linkData } = item;
    return (
        <div className={styles.wrapper}>
            <ContemporaryLandingHeaderModule
                cta={cta}
                imagePath={imagePath}
                onClick={() => trackClick(item)}
                title={caption}
                linkData={linkData}
            />
        </div>
    );
};

export const ContemporaryLandingFurnitureTileModule = createFragmentContainer(
    ContemporaryLandingFurnitureTileModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingFurnitureTileModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingFurnitureTileSection {
                            caption
                            cta
                            imagePath
                            linkData {
                                #SeoButton is used in ContemporaryLandingHeaderModule
                                ...SeoButton_linkData
                            }
                        }
                    }
                }
            }
        `,
    }
);

ContemporaryLandingFurnitureTileModuleComponent.propTypes = {
    contemporaryLandingRow: PropTypes.object,
};
